import React, { Suspense, lazy, useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import First from "./Landingpage/First";
import GoogleOneTapLogin from "./Landingpage/GoogleOneTap";
import CanonicalManager from "./Utils/CanonicalManager";
import RouteSeo from "./Seo/RouteSeo";

const ChatWidget = lazy(() => import("./Landingpage/ChatBot"));
const Privacy = lazy(() => import("./Landingpage/privacy_policy"));
const Termscondition = lazy(() => import("./Landingpage/Terms&condition"));
const Faq = lazy(() => import("./Landingpage/Faq"));
const Pricing = lazy(() => import("./Landingpage/Pricing"));
const ContactForm = lazy(() => import("./Landingpage/Invite"));
const Competitiveresearch = lazy(() =>
  import("./Landingpage/Competitiveresearch")
);
const Domainoverview = lazy(() => import("./Landingpage/Domainoverview"));
const Keywordgap = lazy(() => import("./Landingpage/Keywordgap"));
const Onpageseo = lazy(() => import("./Landingpage/Onpageseo"));
const Seoaudit = lazy(() => import("./Landingpage/Seoauditpage"));
const Page = lazy(() => import("./Landingpage/Page"));
const Structure = lazy(() => import("./Landingpage/Structure"));
const Internallink = lazy(() => import("./Landingpage/Internallink"));
const Sitemappage = lazy(() => import("./Landingpage/Sitemappage"));
const Sociallinks = lazy(() => import("./Landingpage/Sociallink"));
const Robot = lazy(() => import("./Landingpage/Robot"));
const Domainage = lazy(() => import("./Landingpage/Domainage"));
const Linkbuilding = lazy(() => import("./Landingpage/Linkbuilding"));
const Serp = lazy(() => import("./Landingpage/Serp"));
const Keywordresearch = lazy(() => import("./Landingpage/Keywrodresearch"));
const Linkingdomain = lazy(() => import("./Landingpage/Linkingdomain"));
const Googletrend = lazy(() => import("./Landingpage/Googletrend"));
const Trendingnow = lazy(() => import("./Landingpage/Trendingnow"));
const Trendingovertime = lazy(() => import("./Landingpage/Interestovertime"));
const Toppages = lazy(() => import("./Landingpage/Toppages"));
const Risingtopic = lazy(() => import("./Landingpage/Risingtopic"));
const Urlinspect = lazy(() => import("./Landingpage/Url"));
const Keywordbuilder = lazy(() => import("./Landingpage/Keybuilder"));
const Magictool = lazy(() => import("./Landingpage/Magictool"));
const Connectus = lazy(() => import("./Landingpage/Connect"));
const Inspectnow = lazy(() => import("./Landingpage/Inspect"));
const Contentgenerator = lazy(() => import("./Landingpage/Contentgenerator"));
const Contentquality = lazy(() => import("./Landingpage/Qualitycontent"));
const Humanizer = lazy(() => import("./Landingpage/Humanizer"));
const Backlinkchecker = lazy(() => import("./Landingpage/Backlinkchecker"));
const Googleanalytics = lazy(() => import("./Landingpage/Googleanalytics"));
const Googleconsole = lazy(() => import("./Landingpage/Gsearchconsole"));
const Ranksitekeyword = lazy(() => import("./Landingpage/Rankkeyword"));
const Guestpost = lazy(() => import("./Landingpage/Guestpost"));
const Positiontracker = lazy(() => import("./Landingpage/Positiontracker"));
const Partners = lazy(() => import("./Landingpage/Partner"));
const Newregister = lazy(() => import("./Landingpage/Newregister"));
const Blog = lazy(() => import("./Landingpage/Blog"));
const Article = lazy(() => import("./Landingpage/Article"));
const Author = lazy(() => import("./Landingpage/Author"));
const YouTubeTrendingTagsFinder = lazy(() =>
  import("./Landingpage/YouTubeTrendingTagsFinder")
);
const YouTubeBixIntelligence = lazy(() =>
  import("./Landingpage/YouTubeBixIntelligence")
);
const YouTubeScheduledPublishing = lazy(() =>
  import("./Landingpage/YouTubeScheduledPublishing")
);
const YouTubeContentPlanner = lazy(() =>
  import("./Landingpage/YouTubeContentPlanner")
);
const YouTubeSubscriptionTracker = lazy(() =>
  import("./Landingpage/YouTubeSubscriptionTracker")
);
const YouTubeInsightAnalyzer = lazy(() =>
  import("./Landingpage/YouTubeInsightAnalyzer")
);
const FacebookProfilePageAnalyzer = lazy(() =>
  import("./Landingpage/FacebookProfilePageAnalyzer")
);
const FacebookPostContentCreator = lazy(() =>
  import("./Landingpage/FacebookPostContentCreator")
);
const FacebookPostScheduler = lazy(() =>
  import("./Landingpage/FacebookPostScheduler")
);
const FacebookHashtagFinder = lazy(() =>
  import("./Landingpage/FacebookHashtagFinder")
);
const LinkedInProfileAnalyzer = lazy(() =>
  import("./Landingpage/LinkedInProfileAnalyzer")
);
const LinkedInHashtagResearchTool = lazy(() =>
  import("./Landingpage/LinkedInHashtagResearchTool")
);
const LinkedInPostScheduler = lazy(() =>
  import("./Landingpage/LinkedInPostScheduler")
);
const LinkedInPostArticleCreator = lazy(() =>
  import("./Landingpage/LinkedInPostArticleCreator")
);
const InstagramHashtagGenerator = lazy(() =>
  import("./Landingpage/InstagramHashtagGenerator")
);
const InstagramTagAnalyzer = lazy(() =>
  import("./Landingpage/InstagramTagAnalyzer")
);
const InstagramPostScheduler = lazy(() =>
  import("./Landingpage/InstagramPostScheduler")
);
const InstagramPostReelCreator = lazy(() =>
  import("./Landingpage/InstagramPostReelCreator")
);
const InstagramProfileAnalyzer = lazy(() =>
  import("./Landingpage/InstagramProfileAnalyzer")
);
const DigitalMarketingCompanyNoida = lazy(() =>
  import("./Landingpage/DigitalMarketingCompanyNoida")
);
const SeoCompanyNoida = lazy(() => import("./Landingpage/SeoCompanyNoida"));
const SocialMediaMarketingCompanyNoida = lazy(() =>
  import("./Landingpage/SocialMediaMarketingCompanyNoida")
);
const PpcCompanyNoida = lazy(() => import("./Landingpage/PpcCompanyNoida"));
const IncreaseDomainAuthority = lazy(() =>
  import("./Landingpage/IncreaseDomainAuthority")
);

const routeFallback = <div style={{ minHeight: "60vh" }} />;

function SmoothScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [pathname]);

  return null;
}

function App() {
  const [showChat, setShowChat] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowChat(true), 4000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <div>
        <SmoothScrollToTop />
        <CanonicalManager />
        <RouteSeo />
        <GoogleOneTapLogin />
        <main id="main-content">
          <Suspense fallback={routeFallback}>
            <Routes>
              <Route path="/" element={<First />} />
              <Route path="/privacy-policy" element={<Privacy />} />
              <Route
                path="/terms-and-Conditions"
                element={<Termscondition />}
              />
              <Route
                path="/terms-and-conditions"
                element={<Termscondition />}
              />
              <Route path="/pricing-plans" element={<Pricing />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/Blog" element={<Blog />} />
              <Route path="/blog/:post_slug" element={<Article />} />
              <Route path="/contact-us" element={<Connectus />} />
              <Route path="/invite-us" element={<ContactForm />} />
              <Route path="/ChatWidget" element={<ChatWidget />} />
              <Route path="/Sitereport" element={<Inspectnow />} />
              <Route path="/partners" element={<Partners />} />
              <Route path="/guest-post" element={<Guestpost />} />
              <Route path="/register" element={<Newregister />} />
              <Route
                path="/best-keyword-research-tool"
                element={<Magictool />}
              />
              <Route
                path="/bix-keyword-analyzer"
                element={<Ranksitekeyword />}
              />
              <Route
                path="/construct-your-seo-success-with-keyword-builder"
                element={<Keywordbuilder />}
              />
              <Route path="/author/:post_slug" element={<Author />} />
              <Route
                path="/best-url-inspection-tool"
                element={<Urlinspect />}
              />
              <Route path="/top-pages" element={<Toppages />} />
              <Route
                path="/boost-google-ranking-with-keyword-interest"
                element={<Trendingovertime />}
              />
              <Route path="/trending-now-on-google" element={<Trendingnow />} />
              <Route
                path="/linking-domain-checker"
                element={<Linkingdomain />}
              />
              <Route
                path="/increase-google-ranking-with-trending-topics"
                element={<Risingtopic />}
              />
              <Route
                path="/free-google-trends-tool"
                element={<Googletrend />}
              />
              <Route
                path="/best-keyword-research-tool-in-india-2025"
                element={<Keywordresearch />}
              />
              <Route path="/serp-simulator" element={<Serp />} />
              <Route path="/manage-robots-txt" element={<Robot />} />
              <Route
                path="/keyword-position-tracker"
                element={<Positiontracker />}
              />
              <Route path="/structured-data" element={<Structure />} />
              <Route
                path="/boost-your-seo-with-smart-internal-linking-strategies"
                element={<Internallink />}
              />
              <Route
                path="/generate-your-perfect-sitemap-in-seconds-with-our-seobix-tool"
                element={<Sitemappage />}
              />
              <Route
                path="/boost-your-social-media-with-the-best-social-links-generator"
                element={<Sociallinks />}
              />

              <Route path="/on-page-seo-tool" element={<Page />} />
              <Route path="/seo-inspector" element={<Seoaudit />} />
              <Route path="/seo-Inspector" element={<Seoaudit />} />
              <Route
                path="/competitive-research-with-seobix-understand-your-competitors-strategies"
                element={<Competitiveresearch />}
              />
              <Route path="/da-pa-checker" element={<Domainoverview />} />
              <Route path="/keyword-gap" element={<Keywordgap />} />
              <Route
                path="/best-free-on-page-seo-tool-for-high-google-rankings"
                element={<Onpageseo />}
              />
              <Route path="/backlink-checker" element={<Backlinkchecker />} />
              <Route
                path="/domain-age-checker-track-website-journey"
                element={<Domainage />}
              />
              <Route path="/search-console" element={<Googleconsole />} />
              <Route path="/google-analytics" element={<Googleanalytics />} />
              <Route path="/link-building-tool" element={<Linkbuilding />} />
              <Route
                path="/bix-content-generator"
                element={<Contentgenerator />}
              />
              <Route
                path="/content-quality-checker"
                element={<Contentquality />}
              />
              <Route path="/bix-humanizer" element={<Humanizer />} />
              <Route
                path="/digital-marketing-company-noida"
                element={<DigitalMarketingCompanyNoida />}
              />
              <Route path="/seo-company-noida" element={<SeoCompanyNoida />} />
              <Route
                path="/social-media-marketing-company-noida"
                element={<SocialMediaMarketingCompanyNoida />}
              />
              <Route path="/ppc-company-noida" element={<PpcCompanyNoida />} />
              <Route
                path="/increase-domain-authority"
                element={<IncreaseDomainAuthority />}
              />

              <Route
                path="/youtube-scheduled-publishing"
                element={<YouTubeScheduledPublishing />}
              />
              <Route
                path="/youtube-subscription-tracker"
                element={<YouTubeSubscriptionTracker />}
              />
              <Route
                path="/youtube-trending-tags-finder"
                element={<YouTubeTrendingTagsFinder />}
              />
              <Route
                path="/youtube-bix-intelligence"
                element={<YouTubeBixIntelligence />}
              />
              <Route
                path="/youtube-content-planner"
                element={<YouTubeContentPlanner />}
              />
              <Route
                path="/youtube-insight-analyzer"
                element={<YouTubeInsightAnalyzer />}
              />

              {/* --- Facebook Routes --- */}
              <Route
                path="/facebook-profile-page-analyzer"
                element={<FacebookProfilePageAnalyzer />}
              />
              <Route
                path="/facebook-post-content-creator"
                element={<FacebookPostContentCreator />}
              />
              <Route
                path="/facebook-post-scheduler"
                element={<FacebookPostScheduler />}
              />
              <Route
                path="/facebook-hashtag-finder"
                element={<FacebookHashtagFinder />}
              />

              {/* --- LinkedIn Routes --- */}
              <Route
                path="/linkedin-profile-analyzer"
                element={<LinkedInProfileAnalyzer />}
              />
              <Route
                path="/linkedin-post-article-creator"
                element={<LinkedInPostArticleCreator />}
              />
              <Route
                path="/linkedin-post-scheduler"
                element={<LinkedInPostScheduler />}
              />
              <Route
                path="/linkedin-hashtag-research-tool"
                element={<LinkedInHashtagResearchTool />}
              />

              {/* --- Instagram Routes --- */}
              <Route
                path="/instagram-profile-analyzer"
                element={<InstagramProfileAnalyzer />}
              />
              <Route
                path="/instagram-post-reel-creator"
                element={<InstagramPostReelCreator />}
              />
              <Route
                path="/instagram-post-scheduler"
                element={<InstagramPostScheduler />}
              />
              <Route
                path="/instagram-hashtag-generator"
                element={<InstagramHashtagGenerator />}
              />
              <Route
                path="/instagram-tag-analyzer"
                element={<InstagramTagAnalyzer />}
              />
            </Routes>
          </Suspense>
        </main>
      </div>
      {showChat && (
        <Suspense fallback={null}>
          <ChatWidget />
        </Suspense>
      )}
      {/* <BottomBanner /> */}
    </Router>
  );
}

export default App;
